var map = {
	"./FederalView/BQ.png": 6205,
	"./FederalView/CPC.png": 9060,
	"./FederalView/GPC.png": 8704,
	"./FederalView/LPC.png": 251,
	"./FederalView/NDP.png": 1902,
	"./FederalView/PPC.png": 7175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4818;